import { ChangeEvent } from 'preact/compat';

type DropZoneEvent = DragEvent | ChangeEvent<HTMLInputElement>;

const dragEvents = ['dragover', 'dragenter', 'drop'];

export function getDataTransferFiles(event: DropZoneEvent) {
  if (isDragEvent(event) && event.dataTransfer) {
    const dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      return Array.from(dt.files);
    } else if (dt.items && dt.items.length) {
      return Array.from(dt.items);
    }
  } else if (isChangeEvent(event) && event.currentTarget.files) {
    return Array.from(event.currentTarget.files);
  }

  return [];
}

export function fileAccepted(file: File, accepted?: string) {
  return file.type === 'application/x-moz-file' || accepts(file, accepted);
}

export function accepts(file: File, accepted?: string) {
  if (file && accepted) {
    const fileName = file.name || '';
    const mimeType = file.type || '';
    const baseMimeType = mimeType.replace(/\/.*$/, '');

    return accepted.split(',').some((type) => {
      const validType = type.trim();

      if (validType.startsWith('.')) {
        return fileName.toLowerCase().endsWith(validType.toLowerCase());
      } else if (validType.endsWith('/*')) {
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
}

function isDragEvent(event: DropZoneEvent): event is DragEvent {
  return dragEvents.indexOf(event.type) > 0;
}

function isChangeEvent(
  event: DropZoneEvent,
): event is ChangeEvent<HTMLInputElement> {
  return event.type === 'change';
}
